<script lang="ts">
    import {linear} from 'svelte/easing';

    import {duration as durationStore} from 'general/store';

    const flip = (_: Node, {duration}: {duration: number}) => ({
        duration,
        css: (t: number) => `transform: rotateY(${180 - linear(t) * 180}deg);`,
    });
</script>

<style module>
    .flip {
        position: absolute;
        width: 100%;
        height: 100%;
        backface-visibility: hidden;
    }
</style>

<div
    class="flip"
    in:flip={{duration: $durationStore.flip.in}}
    out:flip={{duration: $durationStore.flip.out}}
>
    <slot />
</div>
